import React,{useState} from "react";
import Modal from "@/components/Modal";
import { withFormik, Form, Field, Formik } from "formik";

import { withAuthentication } from "@/hoc/withAuthentication";
import { withRouter } from "react-router-dom";
import * as Yup from "yup";
import { decimalInputHandler } from "@/constants/utility";
import Confirmation from "./Confirmation";

const DialogueBox = ({
  close,
  message = "Please input a value",
  title = "",
  hideModal = false,
  buttonText = "Submit",
  hideText = false,
  isNumber = false,
  label = "",
  inputHandler,
  inputValue,
  validation,
  handleSubmit,
}) => {
  const [confirm, setconfirm] = useState(false)
  const inputListener = {
    onInput: isNumber ? decimalInputHandler : null,
  };

  if (inputHandler) {
    inputListener.onInput = inputHandler;
  }
  const handleDelete = async () => {
    try {
      await handleSubmit('');
    } catch (e) {
      // setSubmitting(false);
    }
  }
  const render = (
    <div className="uk-padding-small uk-width-medium uk-margin-auto ">
      <div className="uk-clearfix">
        <div className="uk-text-bold">{title} <span>{title === 'Update' ? <a
          onClick={() => setconfirm(true)}
          type="button"
          className="uk-float-right uk-text-bold uk-link-reset uk-light uk-margin-left"
          uk-icon="icon:trash; ratio: 1"
        ></a> : ""}</span></div>

        <div className="uk-text-emphasis uk-text-small">{message}</div>

      </div>

      <Formik
        initialValues={{
          inputValue: inputValue || "",
        }}
        validationSchema={Yup.object().shape({
          inputValue: validation || Yup.string().required(),
        })}
        onSubmit={async (values, { resetForm, setSubmitting, setErrors }) => {
          try {
            await handleSubmit(values.inputValue);
          } catch (e) {
            setSubmitting(false);
          }
        }}
      >
        {({ errors, touched, isSubmitting }) => (
          <Form className="uk-form-stacked">
            <div className={"uk-child-width-1-1 uk-grid-small"} uk-grid={1}>
              <div className="uk-width-1-1">
                <label
                  className="uk-form-label uk-text-left"
                  htmlFor="inputValue"
                >
                  {label}
                </label>
                <div className="uk-form-controls">
                  <Field
                    className={[
                      "uk-input",
                      touched.inputValue && errors.inputValue
                        ? "uk-form-danger uk-animation-shake"
                        : "",
                    ].join(" ")}
                    id="inputValue"
                    type={hideText ? "password" : "text"}
                    name="inputValue"
                    placeholder=""
                    autoFocus={true}
                    {...inputListener}
                  />
                </div>
              </div>
            </div>
            <hr className=" uk-divider-icon uk-margin-small" />
            <div
              className="uk-child-width-auto uk-grid-small uk-grid uk-text-center uk-flex-center"
              uk-grid={1}
            >
              {close && (
                <div>
                  <button
                    disabled={isSubmitting}
                    type="button"
                    className="uk-button uk-text-capitalize uk-button-small uk-label-muted"
                    onClick={close}
                  >
                    Cancel
                  </button>
                </div>
              )}
              <div>
                <button
                  type="submit"
                  className="uk-button uk-text-capitalize uk-button-small uk-button-danger"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <i className="fa fa-spinner fa-spin fa-fw"></i>
                  ) : (
                    buttonText
                  )}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      {confirm && <Confirmation
        message={"Are you sure you want to proceed?"}
        onCancel={()=>setconfirm(false)}
        onProceed={()=>{handleDelete(); setconfirm(false)}}
      />}
    </div>
  );

  return !hideModal ? (
    <Modal style={{ top: '35%' }} className="uk-background-muted uk-width-medium uk-border-rounded">
      {render}
    </Modal>
  ) : (
    render
  );
};

export default withAuthentication(withRouter(DialogueBox));
